jQuery(document).ready(commonInit);

function commonInit(){
	
	//don't load anything on init after this in admin editor
	if(jQuery('#wpwrap').length !== 0) return false;
	
	setupMobileMenu();
	setupColumns();
	setupSelectChangeColor();
	setupBanner();
	wrapSelects();
	setupCatSelect();
	
}

function setupMobileMenu(){
	
	jQuery("#mobile-nav").mmenu({

	}, {

		classNames: {
			selected: "current-menu-item",
			fixedElements: {
				
				fixed: "mobile-sticky"
				
			}
			
		}
		
	});
	
}

function setupColumns(){
	
	jQuery('.wp-block-columns').each(function(){
		
		var current = jQuery(this);
		var columnCount = jQuery('> *', current).length;
		
		current.addClass('has-'+columnCount+'-columns');
		
	});
	
}

function setupSelectChangeColor(){
	
	jQuery('select').on('change', function(){
		
		var select = jQuery(this);
		
		select.removeClass("active");
		
		if(select.val() != "")
			select.addClass("active");
		
	});
	
	jQuery(document).on("focus", 'select', function(){
		
		var select = jQuery(this);
		
		select.parent().addClass("focus");
		
	});
	
	jQuery(document).on("blur", 'select', function(){
		
		var select = jQuery(this);
		
		select.parent().removeClass("focus");
		
	});
	
	jQuery('select').each(function(){
		
		var select = jQuery(this);
		
		if(select.val())
			select.addClass('active');
		
	});
	
}

function setupBanner(){
    
    var banner = document.getElementById('global-alert');
    //var closeButton = document.getElementById('close-alert');
    var html = document.getElementsByTagName('html')[0];
    
    if(!banner || !html)
    	return false;
    
    //show banner if it hasn't been closed
    var bannerHasBeenClosed = localStorage.getItem('bannerHasBeenClosed');
    
    if(bannerHasBeenClosed)
    	html.classList.remove('enable-global-alert');
    else
        banner.classList.add('show');
    
/*
    closeButton.addEventListener('click', function(){
        banner.classList.remove('show');
        html.classList.remove('enable-global-alert');
        localStorage.setItem('bannerHasBeenClosed', true);
    });
*/
    
}

function wrapSelects(){
	
	jQuery('#sidebar select[name="archive-dropdown"]').wrap('<div class="select-container"/>');
	
}

function setupCatSelect(){
	
	jQuery('#category-filter').on('change', function(){
		
		var select = jQuery(this);
		var value = select.val();
		
		if(value)
			window.location = '/category/'+value+'/';
		
	});
	
}
